import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const UnsavedChangesNotice = ({ visible, sx }) => {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minHeight: 24,
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-block",
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: "#ff4d4f",
          mr: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
      />
      <Typography variant="body2" sx={{ color: "text.primary", fontSize: 14 }}>
        {t("shiftplan.unsaved_changes")}
      </Typography>
    </Box>
  );
};

export default UnsavedChangesNotice;
